import { Link } from "react-router";

import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
const FooterAuthLegalLinks = () => {
  const {
    features: { footer },
  } = usePublicConfig();

  return footer.links.map((link) => (
    <Link
      aria-label={link.title}
      className="body-base-medium underline cursor-pointer text-text/secondary hover:text-text/primary focus:ring-1 focus:ring-offset-1 focus:ring-offset-transparent focus:ring-brand-default"
      key={link.title}
      rel="noopener noreferrer"
      target="_blank"
      to={link.path}
    >
      {link.title}
    </Link>
  ));
};

export const FooterLinks = ({
  isLoggedIn,
  className,
}: {
  isLoggedIn: boolean;
  className?: string;
}) => {
  const {
    features: { footer },
  } = usePublicConfig();

  return isLoggedIn ? (
    <FooterAuthLegalLinks />
  ) : (
    footer.links.map((link) => (
      <Link
        aria-label={link.title}
        className={cnTwMerge(
          "rich-link text-text/secondary hover:text-text/primary cursor-pointer focus:ring-1 focus:ring-offset-1 focus:ring-offset-transparent focus:ring-brand-default",
          className,
        )}
        key={link.title}
        rel="noopener noreferrer"
        target="_blank"
        to={link.path}
      >
        {link.title}
      </Link>
    ))
  );
};
